import app from 'flarum/forum/app';
import { ladders, shapes, placeText, moneyScale, tenPeople, countText, legend, RUNG_LABELS } from '../../common/standing';

/**
 * "Where will you stand?" on Voucha: the full result. Two ladders (home, there in years 1, 5 and 10), ten people
 * like you, your savings there, what moves you up fastest, and every assumption the numbers rest on.
 */
const SHORT = {
  CA: 'Canada',
  GB: 'the UK',
  US: 'the US',
  IE: 'Ireland',
  DE: 'Germany',
  NL: 'the Netherlands',
  AU: 'Australia',
  NZ: 'New Zealand',
  FI: 'Finland'
};
const LADDER = {
  CA: 'Canada',
  GB: 'UK',
  US: 'US',
  IE: 'Ireland',
  DE: 'Germany',
  NL: 'Netherlands',
  AU: 'Australia',
  NZ: 'New Zealand',
  FI: 'Finland'
};
const SITUATION = {
  offer: 'with a job offer before you arrive',
  'no-offer': 'without a job offer',
  licence: 'in a licensed job, before your licence is recognised'
};
const money = (amount, currency) => {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(amount);
  } catch (e) {
    return currency + ' ' + Math.round(amount).toLocaleString();
  }
};
const naira = n => '₦' + (n >= 1e6 ? (Math.round(n / 1e5) / 10).toLocaleString() + ' million' : Math.round(n).toLocaleString());
const pct = x => Math.round(x * 100) + '%';
export function standingResult(s) {
  const there = SHORT[s.country.code] || s.country.name;
  const [y1, y5, y10] = s.years;
  const marks = [];
  if (s.home) marks.push({
    ladder: 0,
    rung: s.home.rung.key,
    label: 'You now'
  });
  const seen = {};
  s.years.forEach(y => {
    const k = y.rung.key;
    if (seen[k]) seen[k].label += ', ' + y.year;else marks.push(seen[k] = {
      ladder: 1,
      rung: k,
      label: 'Year ' + y.year
    });
  });
  marks.forEach(m => m.label = m.label.replace(/^Year (\d+), (.*)$/, 'Years $1, $2'));
  const used = [...new Set([].concat(y1.ten, y10.ten))];
  const tiers = s.tiers && s.tiers.there ? s.tiers : null;
  // the year nearest to now, for people who have already moved
  const nowYear = s.yearsSinceMove ? s.years.reduce((a, y) => Math.abs(y.year - s.yearsSinceMove) < Math.abs(a.year - s.yearsSinceMove) ? y : a).year : null;
  const cap = t => t.charAt(0).toUpperCase() + t.slice(1);
  return m("div", {
    className: "VStanding"
  }, m("section", {
    className: "VAssessResult-section VStanding-top"
  }, tiers ? m("h2", null, s.home && tiers.home ? cap(placeText(tiers.home, s.home.rung.key)) + ' at home (' + s.home.rung.label + '). ' : '', cap(placeText(tiers.there, y1.rung.key)), " in ", there, " in your first year (", y1.rung.label, ")", y10.rung.key !== y1.rung.key ? ', ' + placeText(tiers.there, y10.rung.key) + ' by year 10 (' + y10.rung.label + ')' : '', ".") : m("h2", null, s.home ? s.home.rung.label + ' at home. ' : '', y1.rung.label, " in ", there, " in your first year", y10.rung.key !== y1.rung.key ? ', ' + y10.rung.label + ' by year 10' : '', "."), m("div", {
    className: "VStanding-pic"
  }, m.trust(tiers ? shapes({
    titles: ['Nigeria', LADDER[s.country.code] || there],
    shares: [tiers.home, tiers.there],
    you: [s.home ? s.home.rung.key : null, y1.rung.key],
    sex: s.sex,
    notes: ['Bar width = share of households.', 'At home you are compared with city households.']
  }) : ladders({
    titles: ['Nigeria (cities)', LADDER[s.country.code] || there],
    marks,
    sex: s.sex
  }))), m("p", {
    className: "VStanding-note"
  }, "Tiers follow Pew Research's income tiers: Middle is two-thirds to twice the country's typical household income, adjusted for household size.", s.home ? ' At home, your household takes home about ' + Math.round(s.home.ratio * 10) / 10 + ' times what the typical city household in Nigeria spends (about ' + naira(s.home.median) + ' a year).' : '')), m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, "Your first ten years in ", there), m("div", {
    className: "VStanding-years"
  }, s.years.map(y => m("div", {
    className: 'VStanding-year' + (y.year === nowYear ? ' is-now' : '')
  }, m("span", {
    className: "VStanding-yearLabel"
  }, "Year ", y.year), m("strong", {
    className: 'VStanding-rung is-' + y.rung.key
  }, y.rung.label), y.low !== y.high ? m("span", {
    className: "VStanding-range"
  }, "Range: ", RUNG_LABELS[y.low], " to ", RUNG_LABELS[y.high]) : m("span", {
    className: "VStanding-range"
  }, "Most people like you"), y.pay ? m("span", {
    className: "VStanding-pay"
  }, "Your own pay, before tax: about ", money(y.pay.amount, y.pay.currency), " a year") : null))), m("div", {
    className: "VStanding-tens"
  }, [y1, y10].map(y => m("div", {
    className: "VStanding-tenRow"
  }, m("span", {
    className: "VStanding-yearLabel"
  }, "Ten people like you, year ", y.year), m.trust(tenPeople(y.ten)), m("span", {
    className: "VStanding-tenText"
  }, countText(y.ten)))), m("ul", {
    className: "VStanding-legend"
  }, legend(used).map(l => m("li", null, m("i", {
    style: 'background:' + l.colour
  }), " ", l.label)))), m("p", {
    className: "VStanding-note"
  }, "You start ", SITUATION[s.situation], ": newcomers like this usually start at ", pct(s.situations.find(x => x.key === s.situation).startLow), " to", ' ', pct(s.situations.find(x => x.key === s.situation).startHigh), " of typical pay for the field", s.situation === 'licence' ? ', in other work until licensed' : '', ", and draw level", ' ', s.situation === 'licence' ? 'about ' + s.catchup.levelYear + ' years after licensing' : 'by year ' + s.catchup.levelYear, ".", s.household.size > 1 ? ' Your household of ' + s.household.size + (s.household.partnerWorks ? ', with your partner working,' : '') + ' is counted.' : '')), s.scale ? m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, "What these tiers mean in ", s.scale.currency === 'USD' ? 'US dollars' : s.scale.currency === 'CAD' ? 'Canadian dollars' : s.scale.currency === 'GBP' ? 'pounds' : s.scale.currency === 'EUR' ? 'euros' : s.scale.currency === 'AUD' ? 'Australian dollars' : s.scale.currency), m("div", {
    className: "VStanding-pic"
  }, m.trust(moneyScale({
    scale: s.scale,
    fmt: v => money(v, s.scale.currency)
  }))), m("p", {
    className: "VStanding-note"
  }, "Where each tier starts, for a household of ", s.scale.household, ", a year, after tax (", s.scale.period, ").", ' ', "The markers are your household's income after tax (", s.household.partnerWorks ? "your pay plus your partner's" : 'your pay', "), not your own pay before tax shown above. They are estimates worked out the same way as your tier, not a pay slip. Source: ", s.scale.source, ".")) : null, s.wealth ? m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, "Your savings there"), m("p", {
    className: "VStanding-big"
  }, naira(s.wealth.naira), s.wealth.amount ? m("span", null, " becomes about ", m("strong", null, money(s.wealth.amount, s.wealth.currency))) : null), m("p", {
    className: "VStanding-note"
  }, s.wealth.months ? 'About ' + s.wealth.months + ' months of typical full-time pay in ' + there + '. ' : '', s.wealth.rateAsOf ? 'At the exchange rate on ' + s.wealth.rateAsOf + ' (Voucha Data Hub).' : '')) : null, m("section", {
    className: "VAssessResult-section"
  }, m("h2", null, "What moves you up fastest"), m("ul", {
    className: "VStanding-tips"
  }, s.situation !== 'offer' ? m("li", null, m("strong", null, "A job offer before you arrive."), " Newcomers with one usually start at ", pct(s.situations[0].startLow), "\u2013", pct(s.situations[0].startHigh), " of typical pay and draw level by year ", s.situations[0].levelYear, "; without one, ", pct(s.situations[1].startLow), "\u2013", pct(s.situations[1].startHigh), " and about ", s.situations[1].levelYear, " years.") : null, s.situation === 'licence' ? m("li", null, m("strong", null, "Start on your licence before you go."), " Until it is recognised, most people work below their field. We assumed ", s.licenceYears, " years; every year saved moves you up sooner.") : null, m("li", null, m("strong", null, "Work in your field there before you land."), " In Canada, half of the newcomers who earned most at the start had Canadian work experience before landing, against fewer than 1 in 10 of those who earned nothing."))), m("details", {
    className: "VAssessResult-section VAssessResult-answersBox"
  }, m("summary", null, "How this was worked out"), m("ul", {
    className: "VStanding-assumptions"
  }, s.assumptions.map(a => m("li", null, a)), m("li", null, "Pay figure for your field: ", s.field.estimate ? 'estimated' : (s.field.jobGroup || '') + (s.field.source ? ', ' : ''), s.field.url ? m("a", {
    href: s.field.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, s.field.source) : s.field.source, "."), m("li", null, "Nigeria: Nigeria Living Standards Survey 2018/19 (via Reall, 2022), brought up to date with World Bank inflation to 2025", s.nigeria.inflationAsOf ? ' and Voucha Data Hub inflation to ' + s.nigeria.inflationAsOf : '', "."), m("li", null, "Ranges are the middle half of people in your field (25th to 75th percentile pay). This is general information to help you plan, not financial advice."))));
}

/** Tag pages to join, only those that exist here: retirement, the destination country, life abroad */
export function standingTags(s) {
  const country = {
    CA: 'canada',
    GB: 'uk',
    US: 'usa'
  }[s.country.code];
  return ['retirement', country, 'diaspora'].filter(Boolean).map(slug => app.store.getBy('tags', 'slug', slug)).filter(Boolean);
}
flarum.reg.add('voucha-assessments', 'forum/components/StandingResult', { standingResult: standingResult,standingTags: standingTags, });